import React, { useState, useEffect, useRef } from "react";
import useHttp from "../../../../hooks/use-http";
import { toast } from "react-toastify";
import { Modal } from "antd";

const OrgWiseDeviceLockUnlockForm = (props) => {
  const [orgId, setOrgId] = useState("");
  const [orgData, setOrgData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [comment, setComment] = useState("");
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewEmployee, setViewEmployee] = useState(null);
  const [unlockHistory, setUnlockHistory] = useState([]);

  const { sendRequest: getUnlockHistory } = useHttp();
  const { sendRequest: getOrg } = useHttp();
  const { sendRequest: getOrgConfigs } = useHttp();
  const { sendRequest: postUnlock } = useHttp();

  const settingRefs = useRef([]);

  const customModalStyles = {
    content: {
      width: "400px",
      margin: "auto",
      padding: "20px",
      borderRadius: "8px",
    },
  };

  useEffect(() => {
    getOrg(
      {
        url: `/api/organisation/`,
      },
      (res) => {
        if (res) setOrgData(res);
      }
    );
  }, []);

  useEffect(() => {
    if (orgId) {
      fetchConfigSettings(orgId);
    } else {
      setEmployeeData([]);
    }
  }, [orgId]);

  const fetchConfigSettings = (orgId) => {
    getOrgConfigs(
      {
        url: `/api/employeeDetail/?orgId=${orgId}`,
      },
      (myres) => {
        if (myres) {
          var data=myres.data
          setEmployeeData(data);
        }
      }
    );
  };

  const handleOrgChange = (e) => {
    setOrgId(e.target.value);
  };

  const { sendRequest: postOrgPermissions } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = employeeData.map((item) => ({
      ...item,
      orgId,
      createdBy: parseInt(localStorage.getItem("id")),
      settingValue: item.hasValue ? item.settingValue : "",
    }));

    postOrgPermissions(
      {
        url: "/api/orgconfigapplications/",
        method: "POST",
        body: data,
      },
      (data) => {
        props.addForm(false);
        toast.success("Organization Permissions Updated");
      }
    );
  };

  useEffect(() => {
    if (props.update && props.update.orgId) {
      setOrgId(props.update.orgId);
      fetchConfigSettings(props.update.orgId); // Fetch config settings for the selected organization
    }
  }, [props.update]);

  const openModal = (employee) => {
    setViewEmployee(employee);

    getUnlockHistory(
      {
        url: `/api/deviceLockUnlock/?employeeId=${employee.empId}`,
      },
      (res) => {
        setUnlockHistory(res || []);
        setIsViewModalOpen(true);
      },
      (err) => {
        toast.error("Failed to load history");
      }
    );
  };

  const handleUnlockSubmit = () => {
    if (!comment.trim()) {
      toast.error("Comment is required!");
      return;
    }

    if (!selectedEmployee) {
      toast.error("No employee selected!");
      return;
    }

    const payload = {
      employeeId: selectedEmployee.empId,
      comment: comment,
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: new Date().toISOString().split("T")[0],
      unlockDate: new Date().toISOString().split("T")[0],
    };

    postUnlock(
      {
        url: "/api/deviceLockUnlock/",
        method: "POST",
        body: payload,
      },
      (res) => {
        toast.success("Device unlocked successfully!");
        setIsModalOpen(false);
        setComment("");
        fetchConfigSettings(orgId); // refresh employee list
      },
      (err) => {
        toast.error("Failed to unlock device");
      }
    );
  };

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={400}
      >
        {selectedEmployee && (
          <div>
            <h5>Unlock Device</h5>
            <p>
              <b>Employee Name:</b> {selectedEmployee.employeeName}
            </p>
            <p>
              <b>Employee Code:</b> {selectedEmployee.employeeCode}
            </p>
            <p>
              <b>Status:</b> {selectedEmployee.androidId ? "Lock" : "Free"}
            </p>
            <p>
              <b>Date:</b> {new Date().toLocaleDateString()}
            </p>

            <div className="form-group">
              <label>Comment*</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter comment"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                required
              />
            </div>

            <button
              className="btn btn-primary w-100 mt-2"
              onClick={handleUnlockSubmit}
            >
              Unlock
            </button>
          </div>
        )}
      </Modal>

      <Modal
        open={isViewModalOpen}
        onCancel={() => setIsViewModalOpen(false)}
        footer={null}
        width={600}
      >
        {viewEmployee && (
          <div>
            <h5>Device Status History - {viewEmployee.employeeName}</h5>
            <table className="table table-bordered text-center">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Status Changed</th>
                  <th>Comment</th>
                </tr>
              </thead>
              <tbody>
                {unlockHistory.length > 0 ? (
                  unlockHistory.map((record) => (
                    <tr key={record.deviceLockUnlockId}>
                      <td>{record.createdDate || record.unlockDate}</td>
                      <td>Free</td>
                      <td>{record.comment}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3">No history found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </Modal>

      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">
                    User Device Lock/ Unlock
                  </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-1"></div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Organization Name</label>
                        <select
                          className="form-control"
                          value={orgId}
                          onChange={handleOrgChange}
                          required
                        >
                          <option value="">Select</option>
                          {orgData.map((x) => (
                            <option key={x.orgId} value={x.orgId}>
                              {x.orgName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Configuration Settings Table */}
                  {employeeData.length > 0 && (
                    <div className="row">
                      <div className="col-md">
                        <table className="table table-bordered text-center table-responsive">
                          <thead>
                            <tr>
                              <th>Profile Pic</th>
                              <th>Employee Name</th>
                              <th>Employee Code</th>
                              <th>Designation</th>
                              <th>Department</th>
                              <th>Email Id</th>
                              <th>Device Lock Status</th>
                              <th>Unlock</th>
                              <th>View</th>
                            </tr>
                          </thead>
                          <tbody>
                            {employeeData.map((item, index) => (
                              <tr key={item.orgConfigSettingId}>
                                <td>
                                  <img
                                    src={`${process.env.REACT_APP_FILE_URL}${item.profileurl}`}
                                    className="user-image img-circle"
                                    width="60"
                                    height="60"
                                    alt="image"
                                  />
                                </td>
                                <td>{item.employeeName}</td>
                                <td>{item.employeeCode}</td>
                                <td>{item.designationName}</td>
                                <td>{item.departmentName}</td>
                                <td>{item.emailId}</td>
                                <td>
                                  {item.androidId && item.androidId.trim() !== ""
                                    ? "Lock"
                                    : "Free"}
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    className="btn"
                                    onClick={() => {
                                      if (
                                        item.androidId &&
                                        item.androidId.trim() !== ""
                                      ) {
                                        // only open if status is "Lock"
                                        setSelectedEmployee(item);
                                        setIsModalOpen(true);
                                      } else {
                                        // optional: show a message
                                        toast.info(
                                          "Device is Free. No action needed."
                                        );
                                      }
                                    }}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => openModal(item)}
                                    className="btn"
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  <hr />

                  <div className="text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default OrgWiseDeviceLockUnlockForm;
